"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaffRoutineCareAddOnScript = void 0;
var _react = _interopRequireWildcard(require("react"));
var PropTypes = _interopRequireWildcard(require("prop-types"));
var _staffModeHelpers = require("../staffModeHelpers");
var _tableContext = require("../../productsTable/stateHelpers/tableContext");
var _staffAddOnWaitingPeriodDetails = require("./staffAddOnWaitingPeriodDetails");
var _staffLimitBreakdownScript = require("../staffLimitBreakdownScript");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StaffRoutineCareAddOnScript = exports.StaffRoutineCareAddOnScript = function StaffRoutineCareAddOnScript(_ref) {
  var plan = _ref.plan;
  var planNumber = plan.planNumber,
    addOns = plan.addOns,
    externalName = plan.externalName;
  var _useContext = (0, _react.useContext)(_tableContext.TableContext),
    _useContext$tableCont = _useContext.tableContext,
    AddOnsMap = _useContext$tableCont.AddOnsMap,
    AllPlans = _useContext$tableCont.AllPlans;
  var _GetOptionalAddons = (0, _staffModeHelpers.GetOptionalAddons)({
      AddOnsMap: AddOnsMap,
      AllPlans: AllPlans,
      planNumber: planNumber,
      addOns: addOns
    }),
    optionalAddOns = _GetOptionalAddons.optionalAddOns,
    maxAddOnLimits = _GetOptionalAddons.maxAddOnLimits,
    limitBreakdown = _GetOptionalAddons.limitBreakdown,
    waitingPeriods = _GetOptionalAddons.waitingPeriods;
  var includesRoutineCare = addOns.indexOf('routineCare') !== -1;
  if (includesRoutineCare) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "staffInstructionsPanel"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "staffScriptItem"
    }, /*#__PURE__*/_react["default"].createElement("strong", null, externalName, " "), "also includes a non-insurance benefit called Routine Care.", /*#__PURE__*/_react["default"].createElement(_staffAddOnWaitingPeriodDetails.StaffAddOnWaitingPeriodDetails, {
      addOnKey: "routineCare",
      plan: plan
    })));
  }
  if (optionalAddOns.indexOf('routineCare') === -1) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "staffInstructionsPanel"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "staffScriptItem"
  }, /*#__PURE__*/_react["default"].createElement("strong", null, externalName, " "), "also has an optional non-insurance benefit called Routine Care", maxAddOnLimits.routineCare && maxAddOnLimits.routineCare.formattedValue && /*#__PURE__*/_react["default"].createElement("span", null, ", that covers up to the value of ", maxAddOnLimits.routineCare.formattedValue, "\xA0per annum for a range of general vet expenses. \xA0The excess does not apply to Routine Care, if selected.")), /*#__PURE__*/_react["default"].createElement("div", {
    className: "staffScriptItem"
  }, /*#__PURE__*/_react["default"].createElement(_staffLimitBreakdownScript.StaffLimitBreakdownScript, {
    limitBreakdown: limitBreakdown.routineCare,
    addOnKey: "routineCare"
  }), /*#__PURE__*/_react["default"].createElement(_staffAddOnWaitingPeriodDetails.StaffAddOnWaitingPeriodDetails, {
    addOnKey: "routineCare",
    plan: plan,
    waitingPeriods: waitingPeriods
  })), /*#__PURE__*/_react["default"].createElement("p", {
    className: "highAccuracy"
  }, "Would you like to include Routine Care as part of your cover today?"));
};
StaffRoutineCareAddOnScript.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  plan: PropTypes.any
};